// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"a83bb669","455":"b41ae4e9","977":"dffe72fe"}[chunkId] + ".chunk.js";
};